import gql from 'graphql-tag';

const ADD_NOTE = gql`
  mutation(
    $content: String!
    $ticket: TicketInput!
    $mentions: [UserInput]
    $inlineImages: [String]
    $attachments: [AttachmentInput]
  ) {
    addNote(
      input: {
        content: $content
        ticket: $ticket
        mentions: $mentions
        inlineImages: $inlineImages
        attachments: $attachments
      }
    ) {
      noteId
      addedBy {
        userId
        firstName
        lastName
        email
      }
      addedOn
      content
      attachments {
        fileName
        originalFileName
        fileSize
      }
      ticket {
        ticketId
        __typename @include(if: false)
      }
    }
  }
`;

const DELETE_NOTE = gql`
  mutation($input: NoteIdentifierInput!) {
    deleteNote(input: $input)
  }
`;

const UPDATE_NOTE = gql`
  mutation($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      noteId
      addedBy {
        userId
        firstName
        lastName
        email
      }
      addedOn
      content
      attachments {
        fileName
        originalFileName
        fileSize
      }
      ticket {
        ticketId
        __typename @include(if: false)
      }
    }
  }
`;

export { ADD_NOTE, DELETE_NOTE, UPDATE_NOTE };
